<template>
  <svg
    :class="customClass"
    width="16"
    height="19"
    viewBox="0 0 16 19"
    :fill="fill"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.835938 18.7288V13.4981C0.835938 12.9929 1.01094 12.5653 1.36094 12.2153C1.71094 11.8653 2.13852 11.6903 2.64369 11.6903H14.0282C14.5334 11.6903 14.9609 11.8653 15.3109 12.2153C15.6609 12.5653 15.8359 12.9929 15.8359 13.4981V18.7288H0.835938ZM2.33594 15.2288H14.3359V13.4981C14.3359 13.4211 14.3039 13.3506 14.2397 13.2866C14.1757 13.2224 14.1052 13.1903 14.0282 13.1903H2.64369C2.56669 13.1903 2.49619 13.2224 2.43219 13.2866C2.36802 13.3506 2.33594 13.4211 2.33594 13.4981V15.2288ZM8.33594 11.6903L3.83594 5.47881V5.38281C3.83594 4.13398 4.27377 3.07181 5.14944 2.19631C6.0251 1.32065 7.08727 0.882812 8.33594 0.882812C9.5846 0.882812 10.6468 1.32065 11.5224 2.19631C12.3981 3.07181 12.8359 4.13398 12.8359 5.38281V5.47881L8.33594 11.6903ZM8.33594 9.51531L11.3359 5.38281C11.3359 4.54948 11.0443 3.84115 10.4609 3.25781C9.8776 2.67448 9.16927 2.38281 8.33594 2.38281C7.5026 2.38281 6.79427 2.67448 6.21094 3.25781C5.6276 3.84115 5.33594 4.54948 5.33594 5.38281L8.33594 9.51531Z"
    />
  </svg>
</template>

<script>
export default {
  name: "ApprovalIcon",
  props: {
    customClass: {
      type: String,
      default: "w-6 h-6",
    },
    fill: {
      type: String,
      default: "#FEBD43", // reverting "#1E2648"
    },
  },
};
</script>
